import VirtualTour from './VirtualTour';
export default VirtualTour;
